import * as React from "react";
import { Zap, ShieldCheck, Users } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KeyBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = [{
    icon: <ShieldCheck className="size-8 text-primary" />,
    title: "Lifetime Solution",
    description: "Dental implants provide a permanent, stable foundation that looks and functions just like your natural teeth for years to come."
  }, {
    icon: <Zap className="size-8 text-primary" />,
    title: "Efficient & Affordable",
    description: "Our streamlined clinical process ensures quality results at a price that fits your budget without compromising on medical standards."
  }, {
    icon: <Users className="size-8 text-primary" />,
    title: "Compassionate Care",
    description: "Experience a gentle touch with our sedation options and a dedicated team focused on your comfort and long-term well-being."
  }];
  return <section data-section-id="31074" id="why-choose-our-implants" ref={ref} className={`py-16 md:py-24 bg-background text-foreground transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-serif font-semibold tracking-tight text-foreground sm:text-5xl mb-4">
            Why Choose Our Implants
          </h2>
          <p className="text-lg font-sans text-muted-foreground max-w-2xl mx-auto">
            Restore your smile with high-end medical precision and the warm, personal care that the El Monte community deserves.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((benefit, i) => <Card key={i} data-index={i} className="border-border/50 border-b-4 border-b-transparent rounded-2xl bg-card shadow-[0_10px_30px_rgba(0,0,0,0.04)] hover:shadow-lg hover:border-b-primary transition-all duration-300">
              <CardHeader className="pb-2">
                <div className="mb-4 inline-flex items-center justify-center rounded-full bg-secondary p-4 w-fit">
                  {benefit.icon}
                </div>
                <CardTitle className="text-2xl font-serif text-foreground">{benefit.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-lg font-sans leading-relaxed text-muted-foreground">
                  {benefit.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}